<template>
  <div class="group">
    <button
      class="btn btn-custom"
      @click="clickPdf"
    >
      <i class="bi bi-filetype-pdf" />
    </button>
    <button
      class="btn btn-custom"
      @click="clickXlsx"
    >
      <i class="bi bi-filetype-xlsx" />
    </button>
    <button
      class="btn btn-custom"
      @click="clickCsv"
    >
      <i class="bi bi-filetype-csv" />
    </button>
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ExportButtons',
  props: {
    csv: Function,
    pdf: Function,
    xlsx: Function,
    details: { Type: Boolean, default: false }
  },
  methods: {
    clickCsv() {
      if (this.csv)
        this.csv('csv', this.details)
    },
    clickPdf() {
      if (this.pdf)
        this.pdf(this.details)
    },
    clickXlsx() {
      if (this.xlsx)
        this.xlsx('xlsx', this.details)
    }
  }
})
</script>

<style lang="scss" scoped>
.group {
  text-align: right;

  button {
    display: inline-block;

    i {
      font-size: 2rem;
    }
  }
}
</style>